import { EventData, EventListener } from '../event/index.js';
class KeyboardEvent extends EventData {
    constructor({ altKey, cancelable, charCode, ctrlKey, key, keyCode, oldValue, preventDefault, shiftKey, stopImmediatePropagation, stopPropagation, value, }) {
        super();
        this.altKey = altKey;
        this.cancelable = cancelable;
        this.charCode = charCode;
        this.ctrlKey = ctrlKey;
        this.key = key;
        this.keyCode = keyCode;
        this.oldValue = oldValue;
        this.preventDefault = preventDefault;
        this.shiftKey = shiftKey;
        this.stopImmediatePropagation = stopImmediatePropagation;
        this.stopPropagation = stopPropagation;
        this.value = value;
    }
}
class KeyboardEventListener extends EventListener {
    constructor() {
        super(KeyboardEvent);
    }
}
export { KeyboardEvent, KeyboardEventListener, };
//# sourceMappingURL=keyboardable.js.map